/**
 * @author Juan Camilo Villa 
 * @version jdesk_1.01.0001
 *  @description: CustomActivosFijosTraslados
 */

import FormJaivana from 'dashboard_jaivana_v1';

class CustomActivosFijosTraslados extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.validarEncabezado = this.validarEncabezado.bind(this);
        this.gridOptionsActivosFijosTraslados = Object.assign({}, this.gridOptions);

        this.allowedExtensions = /(.pdf|.PDF)$/i;
        this.allowedImagesExtensions = /(.jpg|.jpeg|.png|.JPG|.JPEG|.PNG)$/i;
        this.archivoTXT = "";
        this.archivoImagen = "";
        this.accionVerImagen = this.accionVerImagen.bind(this);
        this.accionVerArchivo = this.accionVerArchivo.bind(this);

        this.successGuardar = this.successGuardar.bind(this);
        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.consultarActivosFijosTraslados = this.consultarActivosFijosTraslados.bind(this);
        this.successActivosFijosTraslados = this.successActivosFijosTraslados.bind(this);
        this.setButtonTableActivosFijosTraslados = this.setButtonTableActivosFijosTraslados.bind(this);
        this.crearBotonTabla = this.crearBotonTabla.bind(this);

        ///Variables que trabajan en la Modal 
        this.gridOptionsActivosFijosTrasladosDetalle = Object.assign({}, this.gridOptions);
        this.onSelectionEmpty               = this.onSelectionEmpty.bind(this);
        this.gridOptionsActivosFijosTrasladosDetalle['onSelectionChanged'] = this.onSelectionEmpty();
        this.btn_agregar_traslado_detalle = this.btn_agregar_traslado_detalle.bind(this);
        this.limpiarCamposModal = this.limpiarCamposModal.bind(this);
        this.arrayItems = [];
        this.arrayItems2 = [];
        this.btn_guardar = this.btn_guardar.bind(this);

        this.accionEliminar = this.accionEliminar.bind(this);
        this.successEliminar = this.successEliminar.bind(this);
        this.eliminar = this.eliminar.bind(this);
        this.successEliminarDetalle = this.successEliminarDetalle.bind(this);
        this.confirmarEliminacionRegistro = this.confirmarEliminacionRegistro.bind(this);

        this.accionEliminarItemModal = this.accionEliminarItemModal.bind(this);
        this.setButtonTableModal = this.setButtonTableModal.bind(this);
    
        this.cargaritem = this.cargaritem.bind(this);
        this.successActivosFijoslogisticos = this.successActivosFijoslogisticos.bind(this);
        this.cargardetalles = this.cargardetalles.bind(this);
        this.successcargardetalles = this.successcargardetalles.bind(this);
        this.onSelectionChangedRowTable = this.gridOptiosVacio.bind(this);


        //PDF y Excel
        this.sucursal_ingreso = '';
        this.validarEncabezado = this.validarEncabezado.bind(this);
        this.btn_imprimir = this.btn_imprimir.bind(this);
        this.nombre_archivo_reporte = '';
        this.generarPdfTabla = this.generarPdfTabla.bind(this);
        this.generarPdfTabla3 = this.generarPdfTabla3.bind(this);
        this.generarExcelTabla = this.generarExcelTabla.bind(this);
        this.generarExcelTabla3 = this.generarExcelTabla3.bind(this);
        this.procesar = this.procesar.bind(this);
        this.isJson = this.isJson.bind(this);
        this.enviarCorreoTerceros = this.enviarCorreoTerceros.bind(this);
        this.enviarCorreoDetalle = this.enviarCorreoDetalle.bind(this);
        this.successEnviarCorreo = this.successEnviarCorreo.bind(this);
        this.habilitarCorreo = this.habilitarCorreo.bind(this);
        this.deshabilitarCorreo = this.deshabilitarCorreo.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeEmailEnviado = this.mostrarMensajeEmailEnviado.bind(this);
        this.mostrarMensajeEmailFallo = this.mostrarMensajeEmailFallo.bind(this);
        this.abrirImprimir = this.abrirImprimir.bind(this);
        this.habilitarCampos = this.habilitarCampos.bind(this);
        this.deshabilitarCampos = this.deshabilitarCampos.bind(this);
        this.setButtonVerArchivo = this.setButtonVerArchivo.bind(this);
        this.setButtonImprimir = this.setButtonImprimir.bind(this);
        this.id_traslado = '';
        this.imagen = '';
        this.archivo = '';
        this.fila_seleccionada = [];
        this.fila_seleccionada_traslado = [];
        this.selectedRowsArrayItems = []; 
        this.selectedRowsArray = [];
        this.selectedRows2=[];
        this.detalle = false;
        this.url_noacloud = '';
        this.getUrlNoacloud = this.getUrlNoacloud.bind(this);
        this.successUrlNoacloud = this.successUrlNoacloud.bind(this);
    }

    onSelectionEmpty(){
        
    }

    initForm() {
        console.log("CustomActivosFijosTraslados  @version: jdesk_1.01.0004, @author:Juan Camilo Villa Osorio, @update: Patricia Lopez Sanchez");
        this.consultarActivosFijosTraslados();
        this.getField('rejilla').toggle(false);
        this.getField("btn_abrir_modal_item_detalle").setClick(() => this.validarEncabezado());
        this.getField("btn_consultar").setClick(this.consultarActivosFijosTraslados);
        this.getField("btn_consultar").setDisabled(true);
        this.getField("btn_nuevo").setClick(this.habilitarCampos);
        this.getField("btn_nuevo").setDisabled(true);
        this.getField("btn_cancelar").setClick(() => {this.deshabilitarCampos(); this.consultarActivosFijosTraslados()});

        this.getField('archivos').setOnChange((props) => {
            (props.target.files[0] !== undefined && props.target.files[0] !== " ") ?
            this.archivoTXT = props.target.files[0]: this.archivoTXT = "";
        });
        this.getField('imagenes').setOnChange((props) => {
            ((props.target.files[0] !== undefined && props.target.files[0] !== " ")) ?
            this.archivoImagen = props.target.files[0]: this.archivoImagen = "";
        });

        this.getField("btn_agregar_traslado_detalle").setClick(this.btn_agregar_traslado_detalle);

        this.getField("btn_guardar").setClick(this.btn_guardar);

        ///Pdf y excel
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.getField('ch_excel').setOnChange((props)=>{
            if(this.getField('ch_excel').getValue()==='false'){
                this.getField('ch_pdf').setValueSwitch (false);
                this.operacion_actual='excel';
                this.habilitarCorreo();
            }
        });

        this.getField('ch_pdf').setOnChange((props)=>{
            if(this.getField('ch_pdf').getValue()==='false'){
                this.getField('ch_excel').setValueSwitch (false);
                this.operacion_actual='pdf';
                this.habilitarCorreo();
            }
        });

        ///PDf y excel
        //this.getField("btn_imprimir").setClick(this.btn_imprimir);
        //this.getField("btn_imprimir1").setClick(this.btn_imprimir);
        this.getField('generar_archivo').setClick(()=>this.procesar());
        
        /*this.getField('btn_eliminar_seleccion').setClick(()=>{
            if(this.selectedRowsArray.length> 0){
                this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
                this.getField('confirmModalCustom').setClickDialog(() => this.accionEliminar(this.selectedRowsArray));
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                    this.getField('confirmModalCustom').toggle(false);
                     });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            }else if (this.selectedRowsArray.length === 0){
                this.alertGeneral.toggle(true, 'Debe seleccionar registros a eliminar', 'error');
            }
        });

        this.getField('btn_eliminar_seleccion1').setClick(()=>{
            if(this.selectedRowsArrayItems.length > 0 ){
                this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
                this.getField('confirmModalCustom').setClickDialog(() => this.accionEliminarItemModal(this.selectedRowsArrayItems));
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                    this.getField('confirmModalCustom').toggle(false);
                     });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').toggle(true);
            }else if(this.selectedRowsArrayItems.length === 0){
                this.alertGeneral.toggle(true, 'Debe seleccionar registros a eliminar', 'error');
            }
        });*/

        let hoy= new Date();
        let dia=hoy.getDate();
        let mes=hoy.getMonth()+1;
        let año=hoy.getFullYear();
        if(mes<10){
            mes='0'+mes;
        }
        if(dia<10){
            dia='0'+dia;
        }
        this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
        /*this.getField("modal_agregar_item_traslado").setHandlerClose(()=>{
            this.getField("modal_agregar_item_traslado").handleCloseButton();
            this.getField("bodegaorigen_id").setValue('');
            this.getField("bodegadestino_id").setValue('');
            this.getField("detalle").setValue('');
            this.getField('archivos').handleClickDelete();
            this.getField('imagenes').handleClickDelete();
            this.archivoTXT = '';
            this.archivoImagen = '';
            this.detalle = false;
            this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
        });*/
        this.getUrlNoacloud();
    }

    getUrlNoacloud(){
        this.datosConsultar = { datos: {}};
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosempresas', operacion: 'urlnextcloud', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: this.datosConsultar,
            success: this.successUrlNoacloud,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successUrlNoacloud(data){
        if(data.estado_p === 200){
            this.url_noacloud = data.data[0].valor;
        }
    }

    gridOptiosVacio(){
    }

    /**
     * Valida si el formulario del encabezado está lleno
     */
    validarEncabezado() {
        if ( this.getField('fechasistema').valid() && this.getField('bodegaorigen_id').valid() &&
            this.getField('bodegadestino_id').valid() && this.getField('detalle').valid()) {
                let errores=0;
                if(this.getField('archivos').getValue() !== "" && this.getField('archivos').getValue() !== null && this.getField('archivos').getFile() !== ""){
                    if (!this.allowedExtensions.exec(this.archivoTXT.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten archivos con extensión .pdf/.PDF', 'error');
                        this.getField('archivos').setError(true, "Formato incorrecto");
                        errores++
                    } else if (this.archivoTXT.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'El archivo (' + this.archivoTXT.name + ') No puede contener espacios.', 'error');
                        this.getField('archivos').setError(true, 'Contiene espacios');
                        errores++;
                    }else{
                        this.getField('archivos').setError(false, '');
                    }
                }else{
                    this.archivoTXT = ""
                }
                
                if(this.getField('imagenes').getValue() !== "" && this.getField('imagenes').getValue() !== null && this.getField('imagenes').getFile() !== ""){
                    if (!this.allowedImagesExtensions.exec(this.archivoImagen.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes').setError(true, "Formato incorrecto");
                        errores++;
                    } else if (this.archivoImagen.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes').setError(true, 'Contiene espacios');
                        errores++;
                    }else{
                        this.getField('imagenes').setError(false, '');
                    }
                }else{
                    this.archivoImagen=""
                }

                if(errores === 0){
                    if(this.arrayItems.length > 0){
                        let configCell = new Map();
                        this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = this.arrayItems;
    
                        configCell.set('id', { headerName: 'activo_id' });
                        configCell.set('detalle', { headerName: 'Detalle' });
                        configCell.set('serialactivo', { headerName: 'Serial Activo' });
                        configCell.set('nombre', { headerName: 'Nombre Serie' });
                        configCell.set('nombre_bodega', { headerName: 'Nombre Bodega Activo', width: 300 });
                        configCell.set('accion', { cellRenderer: this.setButtonTableModal, headerName: 'Acción', width: 400, sortable: false, filter: false });
                        this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle, configCell);

                    }
                    this.getField('modal_agregar_item_traslado').handleClickOpen();
                }
            }else{
                this.alertGeneral.toggle(true, 'Debe llenar todos los campos.', 'error');
            }
           
    }

    cargaritem(){
        this.arrayItems = []; 
        this.arrayItems2 = [];
        this.datosConsultar = { datos: {
            bodega_id: parseInt(this.getField('bodegaorigen_id').getValue())
        } };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijosbasicoslog', operacion: '1_2', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: this.datosConsultar,
            success: this.successActivosFijoslogisticos,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successActivosFijoslogisticos(data){
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.descripcion;
                dataOp['campos_cambian'] = { 
                    activos_fijos_basicos_logisticos_id: item.id_original, 
                    nombre_bodega:item.nombre_bodega, 
                    serialactivo:item.serialactivo,
                    nombre_activo: item.nombre
                };
                opciones.push(dataOp);
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('activo_id').setOptions(opciones);
    }

    cargardetalles(){
        this.arrayItems2=[];
        this.datosConsultar = { datos: {
            activos_fijos_traslados_id: parseInt(this.fila_seleccionada_traslado[0].activos_fijos_ajustes_id)
        } };
        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: '1_1', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: this.datosConsultar,
            success: this.successcargardetalles,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successcargardetalles(data){
        if (data.estado_p === 200) {
            //this.getField("btn_eliminar_seleccion1").setVisible(true)
            //this.getField("btn_imprimir1").setVisible(true)
            //let arrayTemp = [];
            data.data.forEach(dato => {
                let item = {
                    "detalle": dato.detalle, 
                    "serialactivo": dato.serialactivo,
                    "activo_id": dato.activo_id,
                    "nombre": dato.nombre,
                    "nombre_bodega": dato.nombre_bodega
                };
                
                this.arrayItems2.push(item);
            });
            let configCell = new Map();
            //arrayTemp = [...this.arrayItems2];

            this.selectedRowsArrayItems = []; // Inicializa el array correctamente
    
            // Configura la función para alternar el valor de la celda y gestionar el array de selección
            /*this.toggleCellValueInRow = (rowNode, columnName) => {
                
                const currentValue = rowNode.data[columnName];
                const newValue = !currentValue; // Alternar entre true y false
    
                // Actualiza el valor de la celda en la fila
                rowNode.setDataValue(columnName, newValue);
    
                // Manejo de la selección
                if (newValue) {
                    // Si está seleccionado, agregar al array si no está ya presente
                    if (!this.selectedRowsArrayItems.some(row => row.activo_id === rowNode.activo_id)) {
                        this.selectedRowsArrayItems.push(rowNode.data);
                    }
                } else {
                    // Si se deselecciona, eliminar del array
                    this.selectedRowsArrayItems = this.selectedRowsArrayItems.filter(row => row.activo_id !== rowNode.data.activo_id);
                }
            };
    
            // Configura el evento de selección de filas
            this.gridOptionsActivosFijosTrasladosDetalle = {
                rowData: arrayTemp,
                rowSelection: 'multiple',
                suppressRowClickSelection: false, 
                onSelectionChanged: () => {
                    this.fila_seleccionada = this.gridOptionsActivosFijosTrasladosDetalle.api.getSelectedRows();
                    if(this.fila_seleccionada.length > 0){
                        this.id_item = this.fila_seleccionada[0].activo_id;
                    }
                },
                onCellClicked: (event) => {
                    const columnName = 'x'; 
            
                    // Obtiene el nodo de fila correspondiente
                    const rowNode = event.node;
                
                    // Alterna el valor en la columna específica de la fila clicada
                    this.toggleCellValueInRow(rowNode, columnName);
                }
            };*/

            configCell.set('id', { headerName: 'activo_id' });
            configCell.set('detalle', { headerName: 'Detalle' });
            configCell.set('serialactivo', { headerName: 'Serial Activo' });
            configCell.set('nombre', { headerName: 'Nombre Serie' });
            configCell.set('nombre_bodega', { headerName: 'Nombre Bodega Activo', width: 300 });
            configCell.set('accion', { cellRenderer: this.setButtonTableModal, headerName: 'Acción', width: 400, sortable: false, filter: false });
            this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle, configCell);
        } else if (data.estado_p === 404) {
            //this.getField("btn_eliminar_seleccion1").setVisible(false)
            //this.getField("btn_imprimir1").setVisible(false)
            this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = [];
            this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle);
            this.getField('rejilla_modal').toggle(false);
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    /**
     Envía todo el formulario al servidor
     */
    btn_guardar() {
        if (this.getField('fechasistema').valid() && this.getField('bodegaorigen_id').valid() &&
            this.getField('bodegadestino_id').valid() && this.getField('detalle').valid()) {

            if (this.arrayItems.length > 0) {

                let errores=0;
                if(this.getField('archivos').getValue() !== "" && this.getField('archivos').getValue() !== null) {
                    if (!this.allowedExtensions.exec(this.archivoTXT.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten archivos con extensión .pdf/.PDF', 'error');
                        this.getField('archivos').setError(true, "Formato incorrecto.");
                        errores++;
                    } else if (this.archivoTXT.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'El archivo (' + this.archivoTXT.name + ') No puede contener espacios.', 'error');
                        this.getField('archivos').setError(true,'Contiene espacios.');
                        errores++;
                    }else{
                        this.getField('archivos').setError(false,'');
                    }
                }
                
                if(this.getField('imagenes').getValue() !== "" && this.getField('imagenes').getValue() !== null){
                    if (!this.allowedImagesExtensions.exec(this.archivoImagen.name)) {
                        this.alertGeneral.toggle(true, 'Solo se permiten imágenes con extensión .jpeg/.jpg/.png', 'error');
                        this.getField('imagenes').setError(true, "Formato incorrecto.");
                        errores++;
                    } else if (this.archivoImagen.name.indexOf(' ') > 0) {
                        this.alertGeneral.toggle(true, 'La imagen (' + this.archivoImagen.name + ') No puede contener espacios.', 'error');
                        this.getField('imagenes').setError(true, 'Contiene espacios.');
                        errores++;
                    }else{
                        this.getField('imagenes').setError(false, '');
                    }
                }
                
                if(errores === 0) {
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está enviando la información... `);
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm('.'); 
                    this.getField('confirmModalCustom').toggle(true);

                    let hoy= new Date();
                    let dia=hoy.getDate();
                    let mes=hoy.getMonth()+1;
                    let año=hoy.getFullYear();
                    if(mes<10){
                        mes='0'+mes;
                    }
                    if(dia<10){
                        dia='0'+dia;
                    }
                    this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
                    const data = {
                        _generales: { "tipo_servicio": "serlog-activosfijostraslados", "operacion": "subirarchivo_traslado", "operacion_tipo": "crear" },
                        archivo: this.archivoTXT,
                        imagen: this.archivoImagen,
                        detalle: this.getField('detalle').getValue(),
                        //fechasistema: String(this.getField('fechasistema').getValue().split(' ')[0]),
                        fechasistema: String(this.getField('fechasistema').getValue()),
                        bodegaorigen_id: this.getField('bodegaorigen_id').getValue(),
                        bodegadestino_id: this.getField('bodegadestino_id').getValue(),
                        items: JSON.stringify(this.arrayItems),
                        id_traslado:""
                    }
                    

                    let url = this.constant.formConfiguration();
                    this.generalFormat = data._generales;
                    this.service.send({
                        endpoint: url,
                        method: 'POST',
                        body: data,
                        success: this.successGuardar,
                        error: this.error_,
                        general: this.generalFormat,
                        formData: true,
                        showMessage: false
                    });
                }
            } else {
                this.alertGeneral.toggle(true, 'Debe agregar al menos 1 ítem', 'error');
            }
        } else {
            this.alertGeneral.toggle(true,'Debe llenar todos los campos, minimo debe adjuntar una imagen o un archivo.', 'error');
        }

    }

    /**
     * Contiene la respuesta del servicio. Si es 200 limpia todos los campos 
     * y actualiza la tabla del encabezado. De lo contrario mostrará un mensaje de error 
     * @param {objeto que contiene la respuesta de la petición} props 
     */
    successGuardar(props) {
        this.getField("confirmModalCustom").setVisibleConfirm(false);
        
        if (props.estado_p === 200) {
            this.limpiarCampos();
            this.limpiarCamposModal();
            this.deshabilitarCampos();
        } else {
            this.alertGeneral.toggle(true, props.data.mensaje, 'error');
        }
        this.getField('confirmModalCustom').toggle(false);

    }

    /**
     * Petición para traer todos los activosFijosTraslados
     */
    consultarActivosFijosTraslados() {
        this.datosConsultar = { datos: {} };
        /*this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: this.datosConsultar,
            success: this.successActivosFijosTraslados,
            error: this.error_,
            general: this.generalFormatPmv
        });*/
        this.getField("rejilla").setTipoServicioOperacion('serlog-activosfijostraslados-1_2');
        this.getField("rejilla").sendRequest(this.successActivosFijosTraslados, this.datosConsultar); 
    }

    /**
     * Arma la tabla con el resultado de la petición
     * @param {Respuesta de la petición} data 
     */
    successActivosFijosTraslados(data) {
        if (data.estado_p === 200) {
            this.getField("btn_consultar").setDisabled(false);
            this.getField("btn_nuevo").setDisabled(false);
            //this.getField('btn_imprimir').setVisible(true);
            //this.getField('btn_eliminar_seleccion').setVisible(true);
            let configCell = new Map();

            this.selectedRowsArray = []; // Inicializa el array correctamente
            this.fila_seleccionada_traslado =[];
    
            // Configura la función para alternar el valor de la celda y gestionar el array de selección
            /*this.toggleCellValueInRow = (rowNode, columnName) => {
                const currentValue = rowNode.data[columnName];
                const newValue = !currentValue; // Alternar entre true y false
    
                // Actualiza el valor de la celda en la fila
                rowNode.setDataValue(columnName, newValue);
    
                // Manejo de la selección
                if (newValue) {
                    // Si está seleccionado, agregar al array si no está ya presente
                    if (!this.selectedRowsArray.some(row => row.activos_fijos_ajustes_id === rowNode.data.activos_fijos_ajustes_id)) {
                        this.selectedRowsArray.push(rowNode.data);
                    }
                } else {
                    // Si se deselecciona, eliminar del array
                    this.selectedRowsArray = this.selectedRowsArray.filter(row => row.activos_fijos_ajustes_id !== rowNode.data.activos_fijos_ajustes_id);
                }
                if(this.selectedRowsArray.length === 0){
                    this.getField("bodegaorigen_id").setDisabled(false);
                    this.getField("bodegadestino_id").setDisabled(false);
                    this.getField("detalle").setDisabled(false);
                    this.getField("bodegaorigen_id").setValue('');
                    this.getField("bodegadestino_id").setValue('');
                    this.getField("detalle").setValue('');
                    this.id_traslado = "";
                }else if(this.selectedRowsArray.length > 0){
                    this.getField("bodegaorigen_id").setError(false,'');
                    this.getField("bodegadestino_id").setError(false,'');
                    this.getField("detalle").setError(false,'');
                    this.getField("bodegaorigen_id").setDisabled(true);
                    this.getField("bodegadestino_id").setDisabled(true);
                    this.getField("detalle").setDisabled(true);
                    this.getField("bodegaorigen_id").setValue(this.bodegaorigen_id);
                    this.getField("bodegadestino_id").setValue(this.bodegadestino_id);
                    this.getField("detalle").setValue(this.detalle1);
                }
            };
    
            // Configura el evento de selección de filas
            this.gridOptionsActivosFijosTraslados = {
                rowData: data.data,
                rowSelection: 'multiple',
                suppressRowClickSelection: false, 
                onSelectionChanged: () => {
                    this.fila_seleccionada_traslado = this.gridOptionsActivosFijosTraslados.api.getSelectedRows();
                    if(this.fila_seleccionada_traslado.length > 0){
                        this.id_traslado = this.fila_seleccionada_traslado[0].activos_fijos_ajustes_id;
                        this.archivo = this.fila_seleccionada_traslado[0].archivos;
                        this.imagen = this.fila_seleccionada_traslado[0].imagenes;
                        this.bodegaorigen_id = this.fila_seleccionada_traslado[0].bodegaorigen_id;
                        this.bodegadestino_id=this.fila_seleccionada_traslado[0].bodegadestino_id;
                        this.detalle1=this.fila_seleccionada_traslado[0].detalle;
                        if(this.selectedRowsArray.length === 0){
                            this.getField("bodegaorigen_id").setValue('');
                            this.getField("bodegadestino_id").setValue('');
                            this.getField("detalle").setValue('');
                            this.id_traslado = "";
                        }
                    }
                },
                onCellClicked: (event) => {
                    const columnName = 'x'; 
            
                    // Obtiene el nodo de fila correspondiente
                    const rowNode = event.node;
                
                    // Alterna el valor en la columna específica de la fila clicada
                    this.toggleCellValueInRow(rowNode, columnName);
                }
            };*/
            this.gridOptionsActivosFijosTraslados['onSelectionChanged'] = ()=>{
                this.fila_seleccionada_traslado = this.gridOptionsActivosFijosTraslados.api.getSelectedRows();
                if(this.fila_seleccionada_traslado.length > 0){
                    this.id_traslado = this.fila_seleccionada_traslado[0].activos_fijos_ajustes_id;
                    this.fecha = this.fila_seleccionada_traslado[0].fechasistema;
                }
            };
            
            configCell.set('detalle', { headerName: 'Detalle' });
            configCell.set('fechasistema', { headerName: 'Fecha' });
            configCell.set('ver_imagen', { cellRenderer: this.setButtonTableActivosFijosTraslados, headerName: 'Ver Imagen', sortable: false, filter: false });
            configCell.set('ver_archivo', { cellRenderer: this.setButtonVerArchivo, headerName: 'Ver Archivo', sortable: false, filter: false });
            configCell.set('imprimir', { cellRenderer: this.setButtonImprimir, headerName: 'Imprimir', sortable: false, filter: false });            this.gridOptionsActivosFijosTraslados.rowData = data.data;
            // Inicializar la tabla
            this.getField('rejilla').initData(this.gridOptionsActivosFijosTraslados, configCell);
        } else {
            this.gridOptionsActivosFijosTraslados.rowData = [];
            this.getField('rejilla').initData(this.gridOptionsActivosFijosTraslados);
            this.getField('rejilla').toggle(false);
            this.getField("btn_nuevo").setDisabled(false);
            //this.getField('btn_imprimir').setVisible(false);
            //this.getField('btn_eliminar_seleccion').setVisible(false);
        }
    }

    /**
     * Establece la creación del botón en la tabla
     * @param {Contiene los valores de la fila seleccionada en la tabla} props 
     */
    setButtonTableActivosFijosTraslados(props) {
        let data = props.data;
        let button = document.createElement("input");
        if (data.imagenes !== undefined && data.imagenes !== null && data.imagenes !== "") {
            button.setAttribute("class", "buttonStyleImg");
            button.onclick = () => { this.accionVerImagen(data) };
        } else {
            button.setAttribute("class", "buttonStyleImgDisabled");
            button.setAttribute("disable", true);
        }
        button.setAttribute('value', 'Ver Imagen');
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `buttonVerImagen_${data.id}`);
        return this.createElementJaivana(button);
    }

    setButtonVerArchivo(props) {
        let data = props.data;
        let button = document.createElement("input");
        if (data.archivos !== undefined && data.archivos !== null && data.archivos !== "") {
            button.setAttribute("class", "buttonStyleActivos");
            button.onclick = () => { this.accionVerArchivo(data) };
        } else {
            button.setAttribute("class", "buttonStyleImgDisabled2");
            button.setAttribute("disable", true);
        }
        button.setAttribute('value', 'Ver Archivo');
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `buttonVerImagen_${data.id}`);
        return this.createElementJaivana(button);
    }
    
    setButtonImprimir(props) {
        let data = props.data;
        let button = document.createElement("input");
        button.setAttribute("class", "buttonStyleImg3");
        button.onclick = () => { this.btn_imprimir()};
        button.setAttribute('value', 'Imprimir');
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `buttonVerImagen_${data.id}`);
        return this.createElementJaivana(button);
    }

    crearBotonTabla(data, nombreBoton) {
        let button = document.createElement('input');
        button.onclick = () => { this.accionVerImagen(data) };
        switch (nombreBoton) {
            case 'Ver Imagen':
                if (data.imagenes !== undefined && data.imagenes !== null && data.imagenes !== "") {
                    button.setAttribute("class", "buttonStyleImg");
                    button.onclick = () => { this.accionVerImagen(data) };
                } else {
                    button.setAttribute("class", "buttonStyleImgDisabled");
                    button.setAttribute("disable", true);
                }
                break;
            case 'Archivos':
                if (data.archivos !== undefined && data.archivos !== null && data.archivos !== "") {
                    button.setAttribute("class", "buttonStyleActivos");
                    button.onclick = () => { this.accionVerArchivo(data) };
                } else {
                    button.setAttribute("class", "buttonStyleImgDisabled2");
                    button.setAttribute("disable", true);
                }
                break;
            default:
                button.setAttribute("class", "buttonStyleImg3");
                button.onclick = () => { this.btn_imprimir() };
                break;
        }
        button.setAttribute('value', nombreBoton);
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `buttonVerImagen_${data.id}`);
        return button;

    }

    /**
     * Establece la creación del botón eliminar de la tabla de los items de la modal
     * @param {Contiene los valores de la fila seleccionada en la tabla} props 
     */
    setButtonTableModal(props) {
        let id = props.data.id;
    
        // Devuelve un botón React directamente
        return (
            <div id={`div_Delete_${id}`}>
                <button
                    id={`button_Delete_${id}`}
                    className="buttonDelete"
                    onClick={() => this.accionEliminarItemModal(props.data)}
                    title="Eliminar" // Añade el atributo title
                >
                    <i className="fas fa-trash-alt" style={{ marginRight: '8px' }}></i>
                </button>
            </div>
        );
    }

    accionEliminarItemModal(data){

        /*if(this.selectedRowsArrayItems.length > 0){

            let array_eliminar=[];
            for (let i = 0; i < this.selectedRowsArrayItems.length; i++) {
                let activoId = this.selectedRowsArrayItems[i].activo_id;
                let isInArrayItems2 = this.arrayItems2.some(item2 => item2.activo_id === activoId);
                let isNotInArrayItems = !this.arrayItems.some(item => item.activo_id === activoId);
        
                if (isInArrayItems2 && isNotInArrayItems) {
                    array_eliminar.push(this.selectedRowsArrayItems[i]);
                }else{
                    let index = this.arrayItems2.indexOf(this.selectedRowsArrayItems[i]);
                    this.arrayItems2.splice(index,1);
                } 
            }

            if(array_eliminar.length>0){
                this.eliminar(array_eliminar);
            }else{
                this.getField('confirmModalCustom').toggle(false);
                if (this.arrayItems2.length > 0) {
                    this.selectedRowsArrayItems = []; // Inicializa el array correctamente

                    // Configura la función para alternar el valor de la celda y gestionar el array de selección
                    this.toggleCellValueInRow = (rowNode, columnName) => {
                        
                        const currentValue = rowNode.data[columnName];
                        const newValue = !currentValue; // Alternar entre true y false
            
                        // Actualiza el valor de la celda en la fila
                        rowNode.setDataValue(columnName, newValue);
            
                        // Manejo de la selección
                        if (newValue) {
                            // Si está seleccionado, agregar al array si no está ya presente
                            if (!this.selectedRowsArrayItems.some(row => row.activo_id === rowNode.activo_id)) {
                                this.selectedRowsArrayItems.push(rowNode.data);
                            }
                        } else {
                            // Si se deselecciona, eliminar del array
                            this.selectedRowsArrayItems = this.selectedRowsArrayItems.filter(row => row.activo_id !== rowNode.data.activo_id);
                        }
                    };
            
                    // Configura el evento de selección de filas
                    this.gridOptionsActivosFijosTrasladosDetalle = {
                        rowData: this.arrayItems2,
                        rowSelection: 'multiple',
                        suppressRowClickSelection: false, 
                        onSelectionChanged: () => {
                            this.fila_seleccionada = this.gridOptionsActivosFijosTrasladosDetalle.api.getSelectedRows();
                            this.id_item = this.fila_seleccionada[0].activo_id;
                        },
                        onCellClicked: (event) => {
                            const columnName = 'x'; 
                    
                            // Obtiene el nodo de fila correspondiente
                            const rowNode = event.node;
                        
                            // Alterna el valor en la columna específica de la fila clicada
                            this.toggleCellValueInRow(rowNode, columnName);
                        }
                    };
                    let configCell = new Map();
                    configCell.set('accion', { cellRenderer: this.setButtonTableModal, headerName: 'Acción', width: 600, sortable: false, filter: false });
                    this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle, configCell);
                    
                } else {
                    this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = [];
                    this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle);
                    this.getField('rejilla_modal').toggle(false);
                } 
            }
        }else{
            let activoId = data.activo_id;
            let isInArrayItems2 = this.arrayItems2.some(item2 => item2.activo_id === activoId);
            let isNotInArrayItems = !this.arrayItems.some(item => item.activo_id === activoId);
    
            if (isInArrayItems2 && isNotInArrayItems) {
                this.eliminar(data);
            }else{
            } */
            let index = this.arrayItems.findIndex(item => item.activo_id === data.activo_id);
            
            if (index !== -1) {
                this.arrayItems.splice(index, 1);
                this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = this.arrayItems;
                let configCell = new Map();
                configCell.set('accion', { cellRenderer: this.setButtonTableModal, headerName: 'Acción', width: 600, sortable: false, filter: false });
                this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle, configCell);
                
            } else {
                //this.getField("btn_eliminar_seleccion1").setVisible(false)
                //this.getField("btn_imprimir1").setVisible(false)
                this.arrayItems = [];
                this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = [];
                this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle);
                this.getField('rejilla_modal').toggle(false);
            }  
        //}
    }

    eliminar(data) {
        /*if(data.length > 0){
            let datos = {
                datos: {
                    items: JSON.stringify(data),
                    activos_fijos_traslados_id: this.fila_seleccionada_traslado[0].activos_fijos_ajustes_id
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: 'eliminar_item_traslados', operacion_tipo: 'eliminar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'DELETE',
                    body: datos,
                    success: this.successEliminarDetalle,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }else{*/
            this.activo_id=data.activo_id;
            let datos = {
                datos: {
                    activo_id: String(data.activo_id),
                    activos_fijos_traslados_id: this.fila_seleccionada_traslado[0].activos_fijos_ajustes_id
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: '7_2', operacion_tipo: 'eliminar' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'DELETE',
                    body: datos,
                    success: this.successEliminarDetalle,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        //}
    }

    successEliminarDetalle(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
           this.cargardetalles();
        }
        else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }


    confirmarEliminacionRegistro(data) {
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Está seguro de realizar esta acción?');
        this.getField('confirmModalCustom').setClickDialog(() => this.accionEliminar(data));
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
             });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
        this.getField('confirmModalCustom').toggle(true);
    }

    accionEliminar(data){

        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está eliminando el registro... `);
        this.getField("confirmModalCustom").setVisibleCancel(true); 
        this.getField("confirmModalCustom").setButtonConfirm('.'); 
        this.getField('confirmModalCustom').toggle(true);
        
        if(this.selectedRowsArray.length > 0){
            const datos = {
                items: JSON.stringify(this.selectedRowsArray)
            }
    
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: 'eliminar_traslados', operacion_tipo: 'eliminar' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'DELETE',
                    body: datos,
                    success: this.successEliminar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    formData: true,
                    showMessage: false
            });
        }else{
            const datos = {
                nombre_archivo: data.archivos,
                nombre_imagen: data.imagenes,
                activos_fijos_ajustes_id : Number(data.activos_fijos_ajustes_id)
            }
    
            this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: 'eliminar_traslados', operacion_tipo: 'eliminar' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'DELETE',
                    body: datos,
                    success: this.successEliminar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    formData: true,
                    showMessage: false
            });
        }
    }

    successEliminar(data){
        this.getField("confirmModalCustom").setButtonConfirm('.'); 
        if (data.estado_p === 200) {
            this.limpiarCampos();
            this.limpiarCamposModal();
        }
        this.getField('confirmModalCustom').toggle(false);
            
    }


    /**
     * Mensaje que se mostrará al usuario cuando se está cargando una imagen ó un archivo 
     */
    mostrarMensajeCargando() {
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, ¡Se está cargando la vista previa! `);
        this.getField("confirmModalCustom").setVisibleCancel(true);
        this.getField("confirmModalCustom").setButtonConfirm('.');
        this.getField('confirmModalCustom').toggle(true);

    }


    /**
     * Acción del botón ver imagen para ver la imagen cargada
     */
    accionVerImagen(data) {
        this.mostrarMensajeCargando();
        let nameImage = data.imagenes;
        let urlImage = this.url_noacloud + '/img_logisticos_activos_fijos_traslados/' + nameImage;
        let url = this.constant.formConfiguration();
        let datos = `?body={"datos":{"url":"${urlImage}"},"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"url_imagen_traslado","operacion_tipo":"consulta"}}`;

        fetch(url + datos, {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                })
            })
            .then(response => {
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();

                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .catch(error => {
            })
            .then(stream => new Response(stream))
            .catch(error => {
            })
            .then(response => {
                return response.blob()
            })
            .catch(error => {
            })
            .then(blob => {
                if (blob.size > 0) {
                    const image = new File([blob], "name.jpeg", {
                        type: "image/jpeg",

                    });
                    window.open(URL.createObjectURL(image))
                } else {
                    this.alertGeneral.toggle(true, 'No hay datos', 'error');
                }
                this.getField('confirmModalCustom').toggle(false); // cuando responda 200 debe ir en false
            })
            .catch(err => {
                return console.error(err);
            });

    }


    /**
     * Botón para ver el archivo de la tabla
     * @param {El objeto seleccionado en la tabla} data 
     */
    accionVerArchivo(data) {
        this.mostrarMensajeCargando();
        let operation = "url_archivo_traslado";
        let nameArchivo = data.archivos;
        let urlArchivo = this.url_noacloud + '/archivos_logisticos_activos_fijos_traslados/' + nameArchivo;
        
        let urlLocal = this.constant.formConfiguration();
        let datos = `?body={"datos":{"url":"${urlArchivo}"},"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"${operation}","operacion_tipo":"consulta"}}`;

        fetch(urlLocal + datos, {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                })
            })
            .then(response => {
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();

                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .catch(error => {
            })
            .then(stream => new Response(stream))
            .catch(error => {
            })
            .then(response => {
                return response.blob()
            })
            .catch(error => {
            })
            .then(blob => {

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = nameArchivo;
                /* a.download = nameArchivo[2]; */
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                this.getField('confirmModalCustom').toggle(false); // cuando responda 200 debe ir en false
            })
            .catch(err => {
                return console.error(err);
            });
    }

    /**
     * Acción del botón Agregar Item.
     * Almacena los items que se van a ir agregando
     */
    btn_agregar_traslado_detalle() {
        if (this.getField("activo_id").getValue() !== "" && this.getField("nombre_bodega").getValue() !== "" &&
            this.getField("detalle_item_traslado").getValue() !== "") {
            
            let errores=0;
            this.arrayItems.forEach(item => {
                let activo = this.getField("activo_id").getValue(); 
                if (item.activo_id === activo) {
                    errores++;
                }
            });
            
            if(errores === 0){
                //this.getField("btn_eliminar_seleccion1").setVisible(true)
                //this.getField("btn_imprimir1").setVisible(true)
                let item = {
                    "detalle": this.getField("detalle_item_traslado").getValue(),
                    "activo_id": this.getField('activo_id').getValue(), 
                    "activo_id_original": this.getField('activos_fijos_basicos_logisticos_id').getValue(), 
                    "serialactivo": this.getField('serialactivo').getValue(),
                    "nombre": this.getField("nombre_activo_buscador").getValue(),
                    "nombre_bodega": this.getField("nombre_bodega").getValue(),
                    "nombre_activo": this.getField("nombre_activo").getValue(),
                    "codigo_activo": this.getField("codigo_activo").getValue()
                };
                this.arrayItems.push(item);
    
                let configCell = new Map();
    
                //this.arrayItems2.push(item);

                this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = this.arrayItems;
    
                configCell.set('id', { headerName: 'activo_id' });
                configCell.set('detalle', { headerName: 'Detalle' });
                configCell.set('codigo_activo', { headerName: 'Codigo Activo', width: 300 });
                configCell.set('serialactivo', { headerName: 'Serial Activo', width: 300  });
                configCell.set('nombre', { headerName: 'Nombre Serie' });
                configCell.set('nombre_bodega', { headerName: 'Nombre Bodega Activo', width: 300 });
                configCell.set('nombre_activo', { headerName: 'Nombre Activo', width: 200 });
                configCell.set('accion', { cellRenderer: this.setButtonTableModal, headerName: 'Acción', width: 400, sortable: false, filter: false });
                this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle, configCell);
                this.limpiarCamposModal();
            }else{
                this.alertGeneral.toggle(true, 'El activo ya fue agregado.', 'error');
            }
        } else {
            this.alertGeneral.toggle(true, 'Debe llenar todos los campos', 'error');
        }
    }

    /**
     * Limpia los campos del encabezado y oculta la tabla
     */
    limpiarCampos() {
        let hoy= new Date();
        let dia=hoy.getDate();
        let mes=hoy.getMonth()+1;
        let año=hoy.getFullYear();
        if(mes<10){
            mes='0'+mes;
        }
        if(dia<10){
            dia='0'+dia;
        }
        this.getField("modal_agregar_item_traslado").handleCloseButton();
        this.getField('archivos').handleClickDelete();
        this.getField('imagenes').handleClickDelete();
        this.archivoTXT = '';
        this.archivoImagen = '';
        this.arrayItems2=[];
        this.arrayItems=[];
        this.getField("bodegaorigen_id").setDisabled(false);
        this.getField("bodegadestino_id").setDisabled(false);
        this.getField("detalle").setDisabled(false);
        this.getField("bodegaorigen_id").setValue("");
        this.getField("bodegadestino_id").setValue("");
        this.getField("detalle").setValue('');
        this.id_traslado = "";
        this.detalle = false;
        this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
        this.gridOptionsActivosFijosTraslados.rowData = [];
        this.getField('rejilla').initData(this.gridOptionsActivosFijosTraslados);
        this.getField('rejilla').toggle(false);
        this.consultarActivosFijosTraslados();
        this.gridOptionsActivosFijosTrasladosDetalle['rowData'] = [];
        this.getField('rejilla_modal').initData(this.gridOptionsActivosFijosTrasladosDetalle);
        this.getField('rejilla_modal').toggle(false);
        this.detalle = false;
        //this.getField("btn_eliminar_seleccion1").setVisible(false)
        //this.getField("btn_imprimir1").setVisible(false)
    }



    /**
     * Limpia los campos que están en la modal
     */
    limpiarCamposModal() {
        this.getField("activo_id").setValue("");
        this.getField("nombre_activo").setValue("");
        this.getField("bodega_id").setValue("");
        this.getField("detalle_item_traslado").setValue("");
        this.getField("nombre_bodega").setValue("");
        this.getField("codigo_activo").setValue("");
        this.getField("nombre_activo_buscador").setValue("");
        this.getField("serialactivo").setValue("");
    }

    btn_imprimir(){
        this.getField('modal_imprimir').handleClickOpen();
    }


    abrirImprimir(){
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
        
        this.getField('email').setDisabled(false);
    }

    generarPdfTabla3()
    {       
            this.nombre_archivo_reporte = 'reporte_activos_fijos_traslados';
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let op='imprimir_traslados';
            let datos2={
                email: this.getField('email').getValue(),
                radio_correo: this.getField('radio_correo').getValue(),
                operacion: this.operacion_actual,
                sucursal_ingreso: this.sucursal_ingreso
            }

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"'+op+'","operacion_tipo":"consulta"}}';

            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const pdf = new File([blob], this.nombre_archivo_reporte+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    generarPdfTabla()
    {       
            this.nombre_archivo_reporte = 'reporte_activos_fijos_traslados_detalle';
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let op='imprimir_traslados_detalle';
            let datos2={
                email: this.getField('email').getValue(),
                radio_correo: this.getField('radio_correo').getValue(),
                operacion: this.operacion_actual,
                sucursal_ingreso: this.sucursal_ingreso,
                activos_fijos_traslados_id:this.id_traslado,
                fecha:this.fecha
            }

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"'+op+'","operacion_tipo":"consulta"}}';

            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const pdf = new File([blob], this.nombre_archivo_reporte+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarExcelTabla3()
    {
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let op='imprimir_traslados';
            let datos2={
                email: this.getField('email').getValue(),
                radio_correo: this.getField('radio_correo').getValue(),
                operacion: this.operacion_actual,
                sucursal_ingreso: this.sucursal_ingreso
            }
            this.nombre_archivo_reporte = 'reporte_activos_fijos_traslados';

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"'+op+'","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
                return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            a.download = this.nombre_archivo_reporte+'.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    generarExcelTabla()
    {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let op='imprimir_traslados_detalle';
        let datos2={
            email: this.getField('email').getValue(),
            radio_correo: this.getField('radio_correo').getValue(),
            operacion: this.operacion_actual,
            sucursal_ingreso: this.sucursal_ingreso,
            activos_fijos_traslados_id:this.id_traslado,
            fecha:this.fecha
        }
        this.nombre_archivo_reporte = 'reporte_activos_fijos_traslados_detalle';

        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"serlog-activosfijostraslados","operacion":"'+op+'","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        
        .then(response => {
        this.getField('confirmModalCustom').toggle(false);
        if(response.status!==200){
            return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                    }else{
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = this.nombre_archivo_reporte+'.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        alert('Se descargo el archivo!');
                    } 
                });
            }else{
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.alertGeneral.toggle(true,err,'error');
        });
    }

    enviarCorreoTerceros(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let operation = 'imprimir_traslados';
        let datos={datos:{
            operacion : this.operacion_actual,
            email : this.getField('email').getValue(),
            radio_correo : this.getField('radio_correo').getValue(),
            operacion_form: this.operacion_form+'',
            sucursal_ingreso:this.sucursal_ingreso,
            fecha:this.fecha
        }}

        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: operation, operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    enviarCorreoDetalle(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let operation = 'imprimir_traslados_detalle';
        let datos={datos:{
            operacion : this.operacion_actual,
            email : this.getField('email').getValue(),
            radio_correo : this.getField('radio_correo').getValue(),
            operacion_form: this.operacion_form+'',
            sucursal_ingreso:this.sucursal_ingreso,
            activos_fijos_traslados_id:this.id_traslado,
            fecha: this.fecha
        }}

        this.generalFormatPmv = { tipo_servicio: 'serlog-activosfijostraslados', operacion: operation, operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    successEnviarCorreo(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeEmailEnviado();
        }else if(data.estado_p ===404){
            this.mostrarMensajeNoHayDatos();
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    procesar(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'){// Se comenta la validación de que sea diferente, ya que en la tarea de corrección "JQJD-1480" pidieron que si en "radio_correo" está seleccionado la opción de "NO", no fuera requerido digitar el correo, ya que en la tabla siempre va a ir 2 ítems, lo que significa que el pdf sólo va a tener una página.
            if(this.getField('email').valid()===false)
                errores++;
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_pdf').getValue()==='false'){
            errores++;
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Pdf ó Excel', 'error');
        }
        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoDetalle();
                    /*if(this.detalle){
                    }else{
                        this.enviarCorreoTerceros();
                    }*/
                }else{
                    if(this.operacion_actual==='pdf'){
                        this.generarPdfTabla();
                        /*if(this.detalle){
                        }else{
                            this.generarPdfTabla3();
                        }*/
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcelTabla();
                        /*if(this.detalle){
                        }else{
                            this.generarExcelTabla3();
                        }*/
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }

    mostrarMensajeEmailEnviado(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
      }

    mostrarMensajeNoHayDatos(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    deshabilitarCorreo(){
        this.getField('email').setDisabled(true);
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setDisabled(true);
        this.getField('radio_correo').setValue("N");
    }
    
    habilitarCorreo(){
        this.getField('email').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);
        this.getField('radio_correo').setValue("N");
    }
    
    habilitarCampos(){
        this.gridOptionsActivosFijosTraslados.rowData = [];
        this.getField('rejilla').initData(this.gridOptionsActivosFijosTraslados);
        this.getField('rejilla').toggle(false);
        this.getField('bodegaorigen_id').setVisible(true);
        this.getField('bodegadestino_id').setVisible(true);
        this.getField('detalle').setVisible(true);
        this.getField('archivos').setVisible(true);
        this.getField('fechasistema').setVisible(true);
        this.getField('imagenes').setVisible(true);
        this.getField('btn_consultar').setVisible(false);
        this.getField('btn_nuevo').setVisible(false);
        this.getField('btn_cancelar').setVisible(true);
        this.getField('btn_abrir_modal_item_detalle').setVisible(true);
        this.getField("bodegaorigen_id").setValue('');
        let hoy= new Date();
        let dia=hoy.getDate();
        let mes=hoy.getMonth()+1;
        let año=hoy.getFullYear();
        if(mes<10){
            mes='0'+mes;
        }
        if(dia<10){
            dia='0'+dia;
        }
        this.getField("bodegadestino_id").setValue('');
        this.getField("detalle").setValue('');
        this.getField('archivos').handleClickDelete();
        this.getField('imagenes').handleClickDelete();
        this.archivoTXT = '';
        this.archivoImagen = '';
        this.detalle = false;
        this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
        this.arrayItems = [];
        this.getField('rejilla_modal').toggle(false);
    }
    
    deshabilitarCampos(){
        this.getField("btn_consultar").setDisabled(true);
        this.getField("btn_nuevo").setDisabled(true);
        this.getField('bodegaorigen_id').setVisible(false);
        this.getField('bodegadestino_id').setVisible(false);
        this.getField('detalle').setVisible(false);
        this.getField('archivos').setVisible(false);
        this.getField('imagenes').setVisible(false);
        this.getField('bodegaorigen_id').setError(false,'');
        this.getField('bodegadestino_id').setError(false,'');
        this.getField('detalle').setError(false,'');
        this.getField('archivos').setError(false,'');
        this.getField('imagenes').setError(false,'');
        this.getField('fechasistema').setVisible(false);
        this.getField('btn_consultar').setVisible(true);
        this.getField('btn_cancelar').setVisible(false);
        this.getField('btn_nuevo').setVisible(true);
        this.getField('btn_abrir_modal_item_detalle').setVisible(false);
        this.getField("bodegaorigen_id").setValue('');
        this.getField("bodegadestino_id").setValue('');
        this.getField("detalle").setValue('');
        this.getField('archivos').handleClickDelete();
        this.getField('imagenes').handleClickDelete();
        this.archivoTXT = '';
        this.archivoImagen = '';
        this.detalle = false;
        let hoy= new Date();
        let dia=hoy.getDate();
        let mes=hoy.getMonth()+1;
        let año=hoy.getFullYear();
        if(mes<10){
            mes='0'+mes;
        }
        if(dia<10){
            dia='0'+dia;
        }
        this.getField("fechasistema").setValue(año+'-'+mes+'-'+dia);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        /* this.getField('consultar').setDisabled(true); */
    
    }

    mostrarMensajeEmailFallo(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
      }

}

FormJaivana.addController("serlog-activosfijostraslados", CustomActivosFijosTraslados);
export default CustomActivosFijosTraslados